import { cx } from '@/utils';

import { Typography } from '@/components/ui/Typography';

type Props = {
  title1?: string | null;
  title2?: string | null;
  description?: string | null;
  action?: { text: string; onClick: () => void };
  classname?: string;
  isDefault?: boolean;
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
  title1ClassName?: string;
  title2ClassName?: string;
  descriptionClassName?: string;
  borderClassName?: string;
};

export const splitTitle = (
  text: string | undefined | null,
  { show, ...options }: { defaultTitle1: string; defaultTitle2: string; show?: boolean }
) => {
  if (!show) return ['', ''];
  if (text) {
    const splittedText = text.split(' ');
    return [splittedText[0], splittedText.slice(1).join(' ')];
  }

  return [options.defaultTitle1, options.defaultTitle2];
};

const TitleWrapper = ({
  title1,
  title2,
  action,
  description,
  classname,
  isDefault,
  wrapperProps,
  title1ClassName,
  title2ClassName,
  descriptionClassName,
  borderClassName,
}: Props) => {
  return (
    <div>
      {(!!title1 || !!title2) && (
        <div
          className={cx(
            'flex w-full flex-row items-start justify-between border-b-2 border-solid pb-[5px] leading-normal md:items-center',
            borderClassName || 'border-primary',
            'title-home2',
            classname
          )}
          {...wrapperProps}
        >
          <div className="flex flex-row flex-wrap items-center">
            {title1 && (
              <div
                className={cx(
                  {
                    'text-xl font-semibold text-primary md:text-[32px]':
                      !title1ClassName || (isDefault && !title1ClassName),
                  },
                  title1ClassName
                )}
              >
                {title1}
              </div>
            )}
            {title2 && (
              <div
                className={cx(
                  {
                    'pl-2  text-xl  md:text-[32px]': !title2ClassName,
                  },
                  title2ClassName
                )}
              >
                {title2}
              </div>
            )}
          </div>
        </div>
      )}
      {description && (
        <Typography
          variant="body1"
          className={cx(
            { 'text-tundora': !isDefault, 'text-white': isDefault && !descriptionClassName },
            descriptionClassName
          )}
        >
          {description}
        </Typography>
      )}
    </div>
  );
};

export default TitleWrapper;
